import { GuardianLogoSvg, GuardianTextLogo } from '@logos'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import { useHistory } from 'react-router-dom'

import './Error404.scss'

function Error404() {
  const history = useHistory()

  return (
    <div className='error404-message-wrapper'>
      <div className='error404-background-image' />

      <div className='error404-message-container'>
        <div className='error404-message-content'>
          <GuardianTextLogo />
          <div className='error-text-wrapper'>
            <div className='error-code'>4</div>
            <GuardianLogoSvg />
            <div className='error-code'>4</div>
          </div>
          <div className='title'>{tr('PORTAL.ERROR404.TITLE', 'Page not found.')}</div>

          <Button
            type='button'
            onClick={() => history.push(paths.dashboard())}
            text={tr('PORTAL.ERROR404.BACK_BUTTON', 'Back to dashboard')}
            data-test='back-button'
          />
        </div>
      </div>
    </div>
  )
}

export default Error404
